<template>
  <v-form v-model="valid" ref="mainForm">
    <adresse-personnelle :carteAffaire="sas.adressePersonnelle" two-columns></adresse-personnelle>
    <opq-date-picker code="date-naissance" v-model="sas.sasPermisPsychotherapeute.dateDeNaissance" :live="liveSasPsychotherapeute(4632)" is-birthdate>
    </opq-date-picker>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
export default {
  mixins: [FormSimple],
  components: { AdressePersonnelle },
  props: {
    sas: { type: Object }
  },
  computed: {
    sasPermisPsychotherapeute() {
      return this.sas.sasPermisPsychotherapeute
    }
  },
  methods: {
    liveSasPsychotherapeute(cle) {
      return { endpoint: "sas-permis-psychotherapeute", cle: cle, fileId: this.sasPermisPsychotherapeute.id }
    }
  }
}
</script>

<style>
</style>